module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00724.91749cf6.jpg";